import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=1d82ad1d&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=1d82ad1d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82ad1d",
  null
  
)

export default component.exports